/**
 * @readonly
 * @enum {string}
 */
export const AreaSpeedProfiles = Object.freeze({
    SPEED_LIMIT: 'speedLimit',
    VEHICLE_TYPE: 'vehicleType'
})
